import React from 'react';
import { useCurrentUser } from './hook';
import { State } from './types';

type ProviderValue = {
  state: State;
  fetchCurrentUser: () => void;
  resetCurrentUser: () => void;
};

const CurrentUserContext = React.createContext<ProviderValue>({
  state: {
    userId: null,
    webStationId: null,
    status: 'idle',
    imageUrl: null,
  },
  fetchCurrentUser: () => {},
  resetCurrentUser: () => {},
});

export const useCurrentUserCtx = () => React.useContext(CurrentUserContext);

export const CurrentUserProvider = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const { state, fetchCurrentUser, resetCurrentUser } = useCurrentUser();

  return (
    <CurrentUserContext.Provider
      value={{ state, fetchCurrentUser, resetCurrentUser }}
    >
      {children}
    </CurrentUserContext.Provider>
  );
};
